import { Button, Stack } from "@mui/material";
import { MouseEvent } from "react";

import { useFormContext } from "components/Forms/AppForm";
import { isDateRangeObject } from "components/Forms/utils/dates.utils";

interface FilterButtonsProps {
  onSubmit?: () => void;
  onReset?: () => void;
  onClear?: () => void;
}

const FilterButtons = ({ onSubmit, onReset, onClear }: FilterButtonsProps) => {
  const form = useFormContext();

  const handleSubmit = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    // allow custom submit behavior
    onSubmit && onSubmit();

    form.handleSubmit();
  };

  const handleReset = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    form.reset();

    // allow custom reset behavior
    onReset && onReset();

    form.handleSubmit();
  };

  const handleClear = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    const formFields = Object.keys(form.state.values);
    const clearedValues = formFields.reduce(
      (acc, field) => {
        const value = form.state.values[field];

        if (Array.isArray(value)) {
          // Empty out our arrays instead of setting to undefined
          acc[field] = [];
        } else if (isDateRangeObject(value)) {
          // Clear out the start and end dates
          acc[field] = { start: undefined, end: undefined, field: "" };
        } else {
          // String handles, text, numbers, radios, selects, and most other things
          acc[field] = "";
        }
        // We may need additional custom types we get more into forms

        return acc;
      },
      {} as Record<string, unknown>,
    );

    form.reset(clearedValues as typeof form.state.values, {
      keepDefaultValues: true,
    });

    // allow custom clear behavior
    onClear && onClear();

    form.handleSubmit();
  };

  return (
    <Stack direction="row" gap={1} m="0 auto">
      <Button type="submit" variant="contained" onClick={handleSubmit}>
        Apply
      </Button>
      <Button type="reset" variant="outlined" onClick={handleReset}>
        Reset
      </Button>
      <Button
        type="reset"
        variant="outlined"
        color="error"
        onClick={handleClear}
      >
        Clear
      </Button>
    </Stack>
  );
};

export default FilterButtons;
